import { Link } from 'react-router-dom';
import { useState } from 'react';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Funcionalidad de newsletter próximamente. Por favor, contáctanos por WhatsApp.');
    setEmail('');
  };

  return (
    <footer className="bg-[#0F172A] text-white overflow-hidden">
      {/* Newsletter Section */}
      <div className="border-b border-white/10">
        <div className="container mx-auto px-4 sm:px-6 py-12 sm:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 items-center">
            <div className="lg:col-span-3">
              <div className="rounded-2xl overflow-hidden h-48 w-full">
                <img
                  src="https://public.readdy.ai/ai/img_res/d9076751556abcc4f65c5d01f92bb1c9.jpg"
                  alt="Trabajo profesional de pintura"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="lg:col-span-5 text-center lg:text-left">
              <h3 className="text-3xl sm:text-4xl lg:text-5xl font-serif leading-tight mb-2">
                ¿Listo para<br />
                transformar<br />
                tu espacio?
              </h3>
            </div>

            <div className="lg:col-span-4">
              <p className="text-gray-300 mb-4 text-sm">
                Recibe consejos y ofertas exclusivas en tu email
              </p>
              <form onSubmit={handleNewsletterSubmit} className="flex gap-2 w-full">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@email.com"
                  required
                  className="flex-1 min-w-0 px-4 sm:px-5 py-3 bg-white/10 border border-white/20 rounded-full text-white placeholder-gray-400 focus:outline-none focus:border-[#2EE6A6] transition-colors text-sm"
                />
                <button
                  type="submit"
                  className="flex-shrink-0 px-5 sm:px-6 py-3 bg-[#2EE6A6] text-[#0F172A] rounded-full font-semibold hover:scale-105 transition-transform cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-arrow-right-line text-xl"></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="container mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-12">
          {/* Logo y descripción */}
          <div className="max-w-full">
            <img
              src="https://public.readdy.ai/ai/img_res/4ea35a69-073a-4757-842e-0e27ab0ba04d.png"
              alt="PINTORDECO Logo"
              className="h-12 w-auto mb-4 max-w-full"
            />
            <p className="text-gray-400 text-sm leading-relaxed break-words">
              Pintor profesional en L'Hospitalet desde 1998. Calidad, limpieza y profesionalidad en cada proyecto.
            </p>
          </div>

          {/* Servicios */}
          <div className="max-w-full">
            <h4 className="text-lg font-bold mb-4 text-white">Servicios</h4>
            <ul className="space-y-2">
              {[
                { to: '/servicios#interior', label: 'Pintura interior' },
                { to: '/servicios#gotele', label: 'Alisar gotelé' },
                { to: '/servicios#lacados', label: 'Esmaltes y lacados' },
                { to: '/servicios#locales', label: 'Locales y oficinas' },
                { to: '/servicios#comunidades', label: 'Comunidades' },
                { to: '/servicios#exterior', label: 'Pintura exterior' }
              ].map((link) => (
                <li key={link.to} className="max-w-full">
                  <Link
                    to={link.to}
                    className="text-gray-400 hover:text-[#2EE6A6] transition-colors text-sm cursor-pointer break-words"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Zonas */}
          <div className="max-w-full">
            <h4 className="text-lg font-bold mb-4 text-white">Zonas</h4>
            <ul className="space-y-2">
              {[
                'Centre',
                'Santa Eulàlia',
                'Collblanc',
                'Bellvitge',
                'Barcelona Sants',
                'Cornellà'
              ].map((zona) => (
                <li key={zona} className="max-w-full">
                  <span className="text-gray-400 text-sm break-words">{zona}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contacto */}
          <div className="max-w-full">
            <h4 className="text-lg font-bold mb-4 text-white">Contacto</h4>
            <ul className="space-y-3">
              <li className="max-w-full">
                <a
                  href="tel:+34690220944"
                  className="text-gray-400 hover:text-[#2EE6A6] transition-colors text-sm flex items-center gap-2 cursor-pointer break-words"
                >
                  <i className="ri-phone-fill flex-shrink-0"></i>
                  <span className="break-words">+34 690 22 09 44</span>
                </a>
              </li>
              <li className="max-w-full">
                <a
                  href="https://wa.me/34690220944"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-[#2EE6A6] transition-colors text-sm flex items-center gap-2 cursor-pointer break-words"
                >
                  <i className="ri-whatsapp-fill flex-shrink-0"></i>
                  <span className="break-words">WhatsApp</span>
                </a>
              </li>
              <li className="max-w-full">
                <a
                  href="mailto:info@pintordeco.com"
                  className="text-gray-400 hover:text-[#2EE6A6] transition-colors text-sm flex items-center gap-2 cursor-pointer break-all"
                >
                  <i className="ri-mail-fill flex-shrink-0"></i>
                  <span className="break-all">info@pintordeco.com</span>
                </a>
              </li>
              <li className="max-w-full">
                <p className="text-gray-400 text-sm flex items-start gap-2">
                  <i className="ri-map-pin-fill mt-0.5 flex-shrink-0"></i>
                  <span className="break-words">Carrer de Sant Eloi, 2, B<br />08038 Barcelona</span>
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-400 text-sm text-center md:text-left max-w-full">
              <p className="font-serif break-words">© 2025 PINTORDECO HOSPITALET</p>
              <p className="text-xs mt-1 break-words">Todos los derechos reservados</p>
            </div>

            <div className="flex flex-wrap gap-4 sm:gap-6 justify-center">
              <Link to="/aviso-legal" className="text-gray-400 hover:text-[#2EE6A6] transition-colors text-sm cursor-pointer whitespace-nowrap">
                Aviso legal
              </Link>
              <Link to="/privacidad" className="text-gray-400 hover:text-[#2EE6A6] transition-colors text-sm cursor-pointer whitespace-nowrap">
                Privacidad
              </Link>
              <Link to="/cookies" className="text-gray-400 hover:text-[#2EE6A6] transition-colors text-sm cursor-pointer whitespace-nowrap">
                Cookies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;